import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';
import Product from './Product.jsx';


var ProductsGroup = React.createClass({

  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

    render() {
        var store = this.state.store;
        const { t, title, products, show_voice_only, is_preorder_available } = this.props;

        var productsCount = products.length;
        if(!productsCount) {
            return false;
        }
        
        var productscols = 'col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1';
        var cardcolclasses = "col-sm-6 col-centered";

        if(productsCount == 6 || productsCount == 3) {
            productscols = "col-sm-12";
            cardcolclasses = "col-md-4 col-md-centered";
        } else if(productsCount == 8) {
            productscols = "col-sm-12";
            cardcolclasses = "col-md-3 col-md-centered";
        }

        let has_ipbb = products.filter(function(p) {
           return p.product_key.indexOf('ipbb') !== -1;
        }).length;

        let show_ipbb_warning = is_preorder_available && has_ipbb; // has_ipbb && !is_preorder_available; Force to false to remove message. Preserving old code incase this gets reenstated.

        const ipbb_warning = (
            <div className={"col-12"}>
                <div style={{backgroundColor: '#27AAE1', padding: '20px 40px', margin: '0px 10px', color: '#fff'}}>
                <p>
                {t('ipbb_warning')}
                </p>
                </div>
            </div>
        );
        return (
      <div className={"col-12"}>
        <div className={"row"}>
            {(show_ipbb_warning ? ipbb_warning : false)}
            <div className={productscols+" row row-centered"}>
                {(title ? <h1 className="col-12">{title}</h1> : false)}
                {products.map(function(product, index){
                    return <Product 
                        key={index} 
                        product={product}
                        cardcolclasses={cardcolclasses}
                        productsCount={productsCount}
                        show_voice_only={show_voice_only}
                    />;
                })}
            </div>
        </div>
    </div>
        );

    }
});

export default  translate('common', { wait: true })(ProductsGroup);
